import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGreenExclamationPoint = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.0781,
			cy: 12,
			r: 11,
			stroke: "#1E762E",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0781 8V13",
			stroke: "#1E762E",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.0781,
			cy: 16,
			r: 1,
			fill: "#1E762E"
		})
	]
});
export default SvgGreenExclamationPoint;
